import { Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import i18n from 'src/i18n';
import { type AmountTooltipLabelData, type CountTooltipLabelData } from 'src/shared/components/Charts/shared/types';
import { AMOUNT_TOOLTIP_LABELS, COUNT_TOOLTIP_LABELS } from 'src/shared/components/Charts/shared/utils';
import LegendCircle, { type LegendCircleProps } from 'src/shared/components/LegendCircle';
import { COUNT_FOR_PLURAL_TRANSLATION } from 'src/shared/helpers/chartHelpers';

export type ChartLegendProps = {
  legendTitle: string;
  circleProps: LegendCircleProps;
};

const translateLabel = (translationKey: string) => {
  if (AMOUNT_TOOLTIP_LABELS[translationKey as keyof AmountTooltipLabelData]) {
    return i18n.t(AMOUNT_TOOLTIP_LABELS[translationKey as keyof AmountTooltipLabelData], {
      ns: 'common',
      count: COUNT_FOR_PLURAL_TRANSLATION
    });
  }
  if (COUNT_TOOLTIP_LABELS[translationKey as keyof CountTooltipLabelData]) {
    return i18n.t(COUNT_TOOLTIP_LABELS[translationKey as keyof CountTooltipLabelData], {
      ns: 'common',
      count: COUNT_FOR_PLURAL_TRANSLATION
    });
  }
  return translationKey;
};

const ChartLegend = ({ legendTitle, circleProps }: ChartLegendProps) => {
  const localizedLabel: string = translateLabel(legendTitle);

  return (
    <Grid2 container sx={{ mr: 2 }}>
      <Grid2 sx={{ mr: 1 }}>
        <LegendCircle {...circleProps} />
      </Grid2>
      <Grid2>
        <Typography variant="h5" fontSize={12} padding={0}>
          {localizedLabel}
        </Typography>
      </Grid2>
    </Grid2>
  );
};

export default ChartLegend;
